import styled from 'styled-components';

export const SettingsContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	background-color: #fff;
`;

export const SettingsHeader = styled.div`
	background-color: #008069;
	color: white;
	padding: 16px;
	display: flex;
	align-items: center;
	gap: 16px;
`;

export const BackButton = styled.button`
	background: none;
	border: none;
	color: white;
	cursor: pointer;
	padding: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}
`;

export const SettingsTitle = styled.h2`
	margin: 0;
	font-size: 20px;
	font-weight: 500;
`;

export const SettingsContent = styled.div`
	flex: 1;
	padding: 20px;
	background-color: #f0f2f5;
	overflow-y: auto;
	min-height: 0;
`;

export const SectionLabel = styled.div`
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.8px;
	color: #54656f;
	padding: 4px 0 8px 0;
	border-bottom: 1px solid #d1d7db;
	margin-bottom: 12px;
`;

export const SettingsOption = styled.button`
	width: 100%;
	padding: 16px;
	display: flex;
	align-items: center;
	gap: 16px;
	text-align: left;
	background: white;
	border: none;
	cursor: pointer;
	color: #54656f;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.08);

	svg {
		width: 24px;
		height: 24px;
		color: #54656f;
	}

	span {
		font-size: 16px;
	}

	&:hover {
		background-color: #f5f6f6;
	}

	${props => props.disabled && `
	cursor: not-allowed;
	opacity: 0.7;
`}
`;